<template>
<section class="hero is-fullheight">
  <div class="hero-body has-text-centered">
    <div class="login">
      <img src="@/assets/img/logo.png" width="450"/>
      <loading :active.sync="isLoading" 
          :can-cancel="false" 
          :is-full-page="false">
      </loading>
      <form v-on:submit.prevent="onSubmit">
        <div class="field">
          <div class="control">
            <input class="input is-medium is-rounded" type="email" placeholder="hello@studentqr.com" v-model="input.email" required />
          </div>
        </div>
        <div class="field">
          <div class="control">
            <input class="input is-medium is-rounded" type="password" placeholder="**********" v-model="input.password" required />
          </div>
        </div>
        <br />
        <button class="button is-block is-fullwidth is-primary is-medium is-rounded" type="submit">
          Login
        </button>
      </form>
      <br>
    </div>
  </div>
</section>
</template>

<script>
import axios from 'axios'
import VueSweetalert2 from 'vue-sweetalert2';
import Loading from 'vue-loading-overlay';
import { ToastProgrammatic as Toast } from 'buefy'

export default {
  name: 'SuperLogin',
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      input: {
        email: "",
        password: ""
      },
      result: "",
    }
  },
  methods: {
    onSubmit(){
        console.log("entering onSubmit")
        let self = this
        try {
            console.log("email: " + self.input.email)
            console.log("password: " + self.input.password)
            if ( (self.input.email != undefined) && (self.input.email.length > 5) && (self.input.password != undefined) && (self.input.password.length > 7) ) {
              self.isLoading = true;
              axios.defaults.responseType = 'json'
              axios.post(process.env.MY_URL + '/super/login', this.input)
                .then(response => {
                  if (response.data.success == false) {
                      Toast.open({
                          message: response.data.msg,
                          type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                          duration: 5000
                      })
                  } else {
                      self.isLoading = false;
                      Toast.open({
                          message: response.data.msg,
                          type: 'is-success',
                          duration: 3000
                      })
                      this.input.email = '';
                      this.input.password = '';

                      console.log("80 response.data")
                      console.log(response.data)

                      localStorage.setItem('superId',response.data.user._id)
                      localStorage.setItem('superEmail',response.data.user.email)
                      localStorage.setItem('jwtToken', response.data.token)

                      if (localStorage.getItem('jwtToken') != null){                                 
                        this.$emit("authenticated", true)
                        this.$emit('loggedIn')
                        this.$router.push({
                          name: "SuperHome"
                        });
                      }
                    }
                })
                .catch(e => {
                  self.isLoading = false;
                  console.log(e.response)
                  if (e.response.status == 400){
                    Toast.open({
                        message: e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                  }else{
                    Toast.open({
                        message: "Sorry, an error has occurred. Please try again: " + e,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                  }
                })
                                  
            }else{
              self.isLoading = false;
              Toast.open({
                  message: "Please enter your login details correctly.",
                  type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                  duration: 3000
              })
              return false;
            }
        }catch(e){
          self.isLoading = false;
          Toast.open({
              message: "Sorry, an error has occurred. Please try again: " + e,
              type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
              duration: 3000
          })
          return false;
        }
    },
  },
}
</script>

<style>
/* :root {
  --shadowDark: #D9DDE6;
  --background: #E4E9F2;
  --shadowLight: #EFF5FE;
}

body {
  background: var(--background);
} */

.hero-body {
  justify-content: center;
}

.login {
  border-radius: 25px;
  padding: 1.5rem;
  box-shadow: 8px 8px 15px var(--shadowDark), -8px -8px 15px var(--shadowLight);
}

input {
  background: var(--shadowDark) !important;
}

a {
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/components/Super/Login.vue